import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Period } from '../entity/period';
import { Rule } from '../entity/rule';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { toRuleTypeTransformer } from '../state/transformers/transformers';
import { RuleType } from '../state/types';
import { BLService } from './bl.service';

@Injectable()
export class PeriodService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'period';
  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  getPeriods(): Observable<Period[]> {
    return this.http
      .get<Period[]>(this.url, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }

  getAvailableRules(period: Period): Observable<Rule[]> {
    return this.http
      .get<Rule[]>(this.url + '/template/' + period.name, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }

  getAvailableRuleTypes(period: Period): Observable<RuleType[]> {
    return this.getAvailableRules(period).pipe(map((rules) => rules.map(toRuleTypeTransformer.transform)));
  }
}
